module.exports = __webpack_public_path__ + "media/images/payments/googlewallet-4ca3a62afc26764afc7da43f17360669.svg";